import React from 'react';
import './Main.css';

const Main = props => (
  <main className="main">
    <div className="main-container">{props.children}</div>
  </main>
);

export default Main;



// WEBPACK FOOTER //
// ./src/Main/Main.js